import React, { FC, useEffect, useState } from 'react';

import { AlertSeverityInitializer } from '@ariksa/notification/api';
import { each, forEach, split } from 'lodash';
import { useSelector } from 'react-redux';

import { selectFindingsOverview } from 'containers/Findings/FindingsOverview/selectors';

import { AlertCount } from './AlertCount';

interface Props {
  category?: string;
  severity?: AlertSeverityInitializer;
}

export const AlertCountForEachCategory: FC<Props> = props => {
  const { category, severity } = props;
  const { aggregateAlertCategories } = useSelector(selectFindingsOverview);
  const [severities, setSeverities] = useState<AlertSeverityInitializer>({});

  useEffect(() => {
    if (!!severity) setSeverities(severity);
    else {
      let items = { CRITICAL: 0, MEDIUM: 0, HIGH: 0, LOW: 0 };
      forEach(aggregateAlertCategories.data, categoryClassSummary => {
        each(categoryClassSummary, s => {
          items.CRITICAL! += s.severity.CRITICAL ?? 0;
          items.HIGH! += s.severity.HIGH ?? 0;
          items.MEDIUM! += s.severity.MEDIUM ?? 0;
          items.LOW! += s.severity.LOW ?? 0;
        });
      });
      setSeverities(items);
    }
  }, [aggregateAlertCategories, category, severity]);

  return (
    <AlertCount
      critical={severities?.CRITICAL ?? 0}
      high={severities?.HIGH ?? 0}
      medium={severities?.MEDIUM ?? 0}
      low={severities?.LOW ?? 0}
      category={split(category, '?')?.[0]}
    />
  );
};
